import { type Href, router } from 'expo-router';
import { useSetAtom } from 'jotai';
import { useEffect } from 'react';
import { Button as TamaguiButton, YStack } from 'tamagui';

import { BodyMediumRegular, H5Emphasized } from '../components/text/Typography';
import { activeThemeAtom } from './BlenderAtoms';
import { BlenderDirectory, type LightOrDarkTheme } from './BlenderDirectory';
import { BlenderLayout } from './BlenderLayout';

export const BlenderOverview = ({
    theme,
    onToggleTheme,
}: {
    theme: LightOrDarkTheme;
    onToggleTheme: (theme: LightOrDarkTheme) => void;
}) => {
    const setActiveTheme = useSetAtom(activeThemeAtom);

    useEffect(() => {
        setActiveTheme(theme);
    }, [theme]);

    return (
        <BlenderLayout
            theme={theme}
            onToggleTheme={(theme) => {
                setActiveTheme(theme);
                onToggleTheme(theme);
            }}
            currentPath="/dev/design-system"
        >
            {BlenderDirectory.map((group) => (
                <YStack key={group.category} gap="$4">
                    <H5Emphasized>{group.category}</H5Emphasized>
                    <YStack gap="$2" paddingLeft="$2">
                        {group.entries.map((component) => {
                            return !component ? null : (
                                <TamaguiButton
                                    key={component.name}
                                    unstyled
                                    cursor="pointer"
                                    onPress={() => {
                                        router.navigate({
                                            pathname:
                                                '/dev/design-system/[component]',
                                            params: {
                                                component: component.name,
                                            },
                                        } as unknown as Href);
                                    }}
                                    paddingVertical="$3"
                                    paddingHorizontal="$4"
                                    borderRadius="$3"
                                    backgroundColor="$gray200"
                                    hoverStyle={{
                                        backgroundColor: '$gray300',
                                    }}
                                    pressStyle={{
                                        backgroundColor: '$gray400',
                                    }}
                                >
                                    <BodyMediumRegular>
                                        {component.title}
                                    </BodyMediumRegular>
                                </TamaguiButton>
                            );
                        })}
                    </YStack>
                </YStack>
            ))}
        </BlenderLayout>
    );
};
